<template>
    <Card v-bind="options">
        <div class="list__conatainer">
            <ul>
                <li v-for="(item, index) in actions" :key="index" class="item__action" @click="selected(item)" :class="{'not-avaible': !item.avaible}">
                    <span class="item__icon"><Icon color="#ffffff" v-bind="item.size ? item.size : null" :icon="item.icon ? item.icon : 'decisionTree'"/></span>
                    <span class="action__name">{{item.name}}</span>
                </li>

            </ul>
            <span class="list__arrow"></span>
        </div>
    </Card>
</template>

<script>
import Card from '../Card.vue'
import Icon from '../Icon.vue'
export default {
    components: { Card, Icon },
    props : { 
        actions : { type : Array, default : []},
        story : { type : Object, default : {}}
    },
    data(){
        return { 
               options :{
                padding : { x : 0, y : 1},
                rounded : .7,
                boxShadow : {x : 5, y : 5, blur : 1, color : '#e5e5e526'},
                hasHeader : false,
                hasfooter : false,
                backgroundColor : "#3d66fc",
                bordered : false,
                main : { 
                     padding : 0
                }
            },
         
        }
    },
    methods : {
        selected(item){
            console.log("action clicked");
            this.$emit('clicked');
            console.log(item)
            item.action(this.story);
        }
    }
}
</script>

<style lang="scss" scoped>
    .list__conatainer {
        display : flex;
        // align-items : center;
    }

    ul {
        padding : 0;
        overflow: hidden;
        position: relative;
        height : 100%;
   
    }

    li {
        display : flex;
        list-style: none;
        color : #ffffff;
        position :relative;
        padding : .5rem 1rem ;
        font-size: .9rem;
        font-weight: 300;
        text-transform: capitalize;
        white-space: nowrap;
        cursor: pointer;
        transition : 1s;
        &:hover {
            color : pink;
             .item__icon span{
                color : pink !important;
            }
            &:after {
                border-color: pink;
            }
        }
        // &:after {
        //     content : "";
        //     border : 1px dashed rgb(197, 197, 197);
        //     width: 100%;
        //     position : absolute;
        //     left : 2.7rem;
        //     top : 1rem;
        //     margin : .5rem 0;
        // }
    }

    .item__icon {
            color : #ffffff;
            padding-right : 1rem ;
        svg {
            fill : #ffffff;
            width: 1.5rem;
        }
    }
    .list__arrow {
        position: relative;
        border-top: 4px solid #3d66fc;
        border-right: 4px solid #3d66fc;
        background-color:  #3d66fc;
        height: 1.5rem;
        width: 1.5rem;
        transform: rotate(50deg);
        margin-right: .5rem;
        right : -1rem;
        top : 11.2rem;
    }
    
    .not-avaible {
        text-decoration: line-through;
    }

</style>


// WEBPACK FOOTER //
// src/components/global/sections/Actions.vue